import { useContext } from 'react'

import CollapsibleScoreboardContext from '@contexts/collapsibleScoreboardContext'

const useIsInCollapsibleScoreboard = (): boolean =>
  !!useContext(CollapsibleScoreboardContext)

export default useIsInCollapsibleScoreboard
